<script>
    import _ from 'lodash';

    export default {
        data() {
            return {
                bpsys: {
                    id: 'bpsys',
                    name: 'АДсис',
                    description: 'Систолическое артериальное давление',
                    dimension: 'мм рт. ст.',
                    data: [],
                    min: 0,
                    max: 220,
                    diagnosis: {
                        1: {
                            is: function (x) {
                                return x > 190;
                            },
                            msg: 'Гипертонический криз (критическое состояние)',
                            style: 'dark'
                        },
                        2: {
                            is: function (x) {
                                return _.inRange(x, 171, 191);
                            },
                            msg: 'Тяжёлая артериальная гипертензия',
                            style: 'danger'
                        },
                        3: {
                            is: function (x) {
                                return _.inRange(x, 151, 171);
                            },
                            msg: 'Артериальная гипертензия средней тяжести',
                            style: 'primary'
                        },
                        4: {
                            is: function (x) {
                                return _.inRange(x, 131, 151);
                            },
                            msg: 'Лёгкая артериальная гипертензия',
                            style: 'warning'
                        },
                        5: {
                            is: function (x) {
                                return _.inRange(x, 111, 131);
                            },
                            msg: 'Артериальная нормотензия',
                            style: 'success'
                        },
                        6: {
                            is: function (x) {
                                return _.inRange(x, 91, 111);
                            },
                            msg: 'Лёгкая артериальная гипотензия',
                            style: 'warning'
                        },
                        7: {
                            is: function (x) {
                                return _.inRange(x, 71, 91);
                            },
                            msg: 'Выраженная артериальная гипотензия',
                            style: 'primary'
                        },
                        8: {
                            is: function (x) {
                                return _.inRange(x, 51, 71);
                            },
                            msg: 'Тяжёлая артериальная гипотензия',
                            style: 'danger'
                        },
                        9: {
                            is: function (x) {
                                return x < 51;
                            },
                            msg: 'Шок (критическое состояние)',
                            style: 'dark'
                        }
                    }
                },
                bpdia: {
                    id: 'bpdia',
                    name: 'АДдиа',
                    description: 'Диастолическое артериальное давление',
                    dimension: 'мм рт. ст.',
                    data: [],
                    min: 0,
                    max: 220,
                    diagnosis: {
                        10: {
                            is: function (x) {
                                return x > 110;
                            },
                            msg: 'Крайне тяжёлая диастолическая гипертония',
                            style: 'dark'
                        },
                        11: {
                            is: function (x) {
                                return _.inRange(x, 101, 111);
                            },
                            msg: 'Тяжёлая диастолическая гипертония',
                            style: 'danger'
                        },
                        12: {
                            is: function (x) {
                                return _.inRange(x, 91, 101);
                            },
                            msg: 'Диастолическая гипертония средней тяжести',
                            style: 'primary'
                        },
                        13: {
                            is: function (x) {
                                return _.inRange(x, 81, 91);
                            },
                            msg: 'Лёгкая диастолическая гипертония',
                            style: 'warning'
                        },
                        14: {
                            is: function (x) {
                                return _.inRange(x, 61, 81);
                            },
                            msg: 'Диастолическая нормотония',
                            style: 'success'
                        },
                        15: {
                            is: function (x) {
                                return _.inRange(x, 51, 61);
                            },
                            msg: 'Лёгкая диастолическая гипотония',
                            style: 'warning'
                        },
                        16: {
                            is: function (x) {
                                return _.inRange(x, 41, 51);
                            },
                            msg: 'Диастолическая гипотония средней тяжести',
                            style: 'primary'
                        },
                        17: {
                            is: function (x) {
                                return _.inRange(x, 31, 41);
                            },
                            msg: 'Тяжёлая диастолическая гипотония',
                            style: 'danger'
                        },
                        18: {
                            is: function (x) {
                                return x < 31;
                            },
                            msg: 'Крайне тяжёлая диастолическая гипотония',
                            style: 'dark'
                        }
                    }
                },
                hr: {
                    id: 'hr',
                    name: 'ЧСС',
                    description: 'Частота сердечных сокращений',
                    dimension: 'уд/мин',
                    data: [],
                    min: 0,
                    max: 200,
                    diagnosis: {
                        19: {
                            is: function (x) {
                                return x > 106;
                            },
                            msg: 'Тахикардия с риском фибрилляции',
                            style: 'dark'
                        },
                        20: {
                            is: function (x) {
                                return _.inRange(x, 97, 107);
                            },
                            msg: 'Тяжёлая тахикардия',
                            style: 'danger'
                        },
                        21: {
                            is: function (x) {
                                return _.inRange(x, 87, 97);
                            },
                            msg: 'Выраженная тахикардия',
                            style: 'primary'
                        },
                        22: {
                            is: function (x) {
                                return _.inRange(x, 77, 87);
                            },
                            msg: 'Лёгкая тахикардия',
                            style: 'warning'
                        },
                        23: {
                            is: function (x) {
                                return _.inRange(x, 55, 77);
                            },
                            msg: 'Нормокардия',
                            style: 'success'
                        },
                        24: {
                            is: function (x) {
                                return _.inRange(x, 45, 55);
                            },
                            msg: 'Брадикардия',
                            style: 'warning'
                        },
                        25: {
                            is: function (x) {
                                return x < 45;
                            },
                            msg: 'Брадикардия с риском AV-блокады',
                            style: 'danger'
                        }
                    }
                },
                rr: {
                    id: 'rr',
                    name: 'ЧД',
                    description: 'Частота дыхания',
                    dimension: 'экс/мин',
                    data: [],
                    min: 0,
                    max: 28,
                    diagnosis: {
                        26: {
                            is: function (x) {
                                return x < 9;
                            },
                            msg: 'Отличная функция внешнего дыхания',
                            style: 'success'
                        },
                        27: {
                            is: function (x) {
                                return _.inRange(x, 9, 13);
                            },
                            msg: 'Хорошая функция внешнего дыхания',
                            style: 'success'
                        },
                        28: {
                            is: function (x) {
                                return _.inRange(x, 13, 19);
                            },
                            msg: 'Удовлетворительная функция внешнего дыхания',
                            style: 'success'
                        },
                        29: {
                            is: function (x) {
                                return _.inRange(x, 19, 25);
                            },
                            msg: 'Достаточная функция внешнего дыхания',
                            style: 'warning'
                        },
                        30: {
                            is: function (x) {
                                return x > 24;
                            },
                            msg: 'Ослабленная функция внешнего дыхания',
                            style: 'primary'
                        }
                    }
                },
                COa: {
                    id: 'COa',
                    name: 'МОСа',
                    description: 'Минутный объём сердца (левый желудочек)',
                    dimension: 'л/мин',
                    data: [],
                    min: 0,
                    max: 15,
                    diagnosis: {
                        31: {
                            is: function (x) {
                                return x > 7.5;
                            },
                            msg: 'Крайне тяжёлая перегрузка минутной продуктивности сердца по ЛЖ',
                            style: 'dark'
                        },
                        32: {
                            is: function (x) {
                                return _.inRange(x, 7.1, 7.6);
                            },
                            msg: 'Тяжёлая перегрузка минутной продуктивности сердца по ЛЖ',
                            style: 'danger'
                        },
                        33: {
                            is: function (x) {
                                return _.inRange(x, 6.6, 7.1);
                            },
                            msg: 'Значительное повышение минутной продуктивной работы сердца по ЛЖ',
                            style: 'primary'
                        },
                        34: {
                            is: function (x) {
                                return _.inRange(x, 6.1, 6.6);
                            },
                            msg: 'Повышение минутной продуктивной работы сердца по ЛЖ',
                            style: 'warning'
                        },
                        35: {
                            is: function (x) {
                                return _.inRange(x, 4.1, 6.1);
                            },
                            msg: 'Удовлетворительная минутная продуктивная работа сердца по ЛЖ',
                            style: 'success'
                        },
                        36: {
                            is: function (x) {
                                return _.inRange(x, 3.5, 4.1);
                            },
                            msg: 'Снижение минутной продуктивной работы сердца по ЛЖ',
                            style: 'warning'
                        },
                        37: {
                            is: function (x) {
                                return _.inRange(x, 3.0, 3.5);
                            },
                            msg: 'Значительное снижение минутной продуктивности сердца по ЛЖ',
                            style: 'primary'
                        },
                        38: {
                            is: function (x) {
                                return _.inRange(x, 2.5, 3.0);
                            },
                            msg: 'Левожелудочковая сердечная недостаточность',
                            style: 'danger'
                        },
                        39: {
                            is: function (x) {
                                return x < 2.5;
                            },
                            msg: 'Тяжёлая левожелудочковая сердечная недостаточность',
                            style: 'dark'
                        }
                    }
                },
                COv: {
                    id: 'COv',
                    name: 'МОСв',
                    description: 'Минутный объём сердца (правый желудочек)',
                    dimension: 'л/мин',
                    data: [],
                    min: 0,
                    max: 15,
                    diagnosis: {
                        40: {
                            is: function (x) {
                                return x > 7.5;
                            },
                            msg: 'Крайне тяжёлая перегрузка минутной продуктивности сердца по ПЖ',
                            style: 'dark'
                        },
                        41: {
                            is: function (x) {
                                return _.inRange(x, 7.1, 7.6);
                            },
                            msg: 'Тяжёлая перегрузка минутной продуктивности сердца по ПЖ',
                            style: 'danger'
                        },
                        42: {
                            is: function (x) {
                                return _.inRange(x, 6.6, 7.1);
                            },
                            msg: 'Значительное повышение минутной продуктивной работы сердца по ПЖ',
                            style: 'primary'
                        },
                        43: {
                            is: function (x) {
                                return _.inRange(x, 6.1, 6.6);
                            },
                            msg: 'Повышение минутной продуктивной работы сердца по ПЖ',
                            style: 'warning'
                        },
                        44: {
                            is: function (x) {
                                return _.inRange(x, 4.1, 6.1);
                            },
                            msg: 'Удовлетворительная минутная продуктивная работа сердца по ПЖ',
                            style: 'success'
                        },
                        45: {
                            is: function (x) {
                                return _.inRange(x, 3.5, 4.1);
                            },
                            msg: 'Снижение минутной продуктивной работы сердца по ПЖ',
                            style: 'warning'
                        },
                        46: {
                            is: function (x) {
                                return _.inRange(x, 3.0, 3.5);
                            },
                            msg: 'Значительное снижение минутной продуктивности сердца по ПЖ',
                            style: 'primary'
                        },
                        47: {
                            is: function (x) {
                                return _.inRange(x, 2.5, 3.0);
                            },
                            msg: 'Правожелудочковая сердечная недостаточность',
                            style: 'danger'
                        },
                        48: {
                            is: function (x) {
                                return x < 2.5;
                            },
                            msg: 'Тяжёлая правожелудочковая сердечная недостаточность',
                            style: 'dark'
                        }
                    }
                },
                SVa: {
                    id: 'SVa',
                    name: 'УОа',
                    description: 'Ударный объём (левый желудочек сердца)',
                    dimension: 'б/в',
                    data: [],
                    min: 0,
                    max: 3.5,
                    converter: function (x) {
                        return Math.round(100 * x / 81) / 100;
                    },
                    diagnosis: {
                        49: {
                            is: function (x) {
                                return x > 110;
                            },
                            msg: 'Угрожающее повышение левожелудочкового сердечного выброса',
                            style: 'danger'
                        },
                        50: {
                            is: function (x) {
                                return _.inRange(x, 101, 111);
                            },
                            msg: 'Значительное повышение левожелудочкового сердечного выброса',
                            style: 'primary'
                        },
                        51: {
                            is: function (x) {
                                return _.inRange(x, 91, 101);
                            },
                            msg: 'Повышенный левожелудочковый сердечный выброс',
                            style: 'warning'
                        },
                        52: {
                            is: function (x) {
                                return _.inRange(x, 71, 91);
                            },
                            msg: 'Нормальный левожелудочковый сердечный выброс',
                            style: 'success'
                        },
                        53: {
                            is: function (x) {
                                return _.inRange(x, 61, 71);
                            },
                            msg: 'Сниженный левожелудочковый сердечный выброс',
                            style: 'warning'
                        },
                        54: {
                            is: function (x) {
                                return _.inRange(x, 51, 61);
                            },
                            msg: 'Значительное снижение левожелудочкового сердечного выброса',
                            style: 'primary'
                        },
                        55: {
                            is: function (x) {
                                return x < 51;
                            },
                            msg: 'Угрожающее снижение левожелудочкового сердечного выброса',
                            style: 'danger'
                        }
                    }
                },
                SVv: {
                    id: 'SVv',
                    name: 'УОв',
                    description: 'Ударный объём (правый желудочек сердца)',
                    dimension: 'б/в',
                    data: [],
                    min: 0,
                    max: 3.5,
                    converter: function (x) {
                        return Math.round(100 * x / 70.5) / 100;
                    },
                    diagnosis: {
                        56: {
                            is: function (x) {
                                return x > 100;
                            },
                            msg: 'Угрожающее повышение правожелудочкового сердечного выброса',
                            style: 'danger'
                        },
                        57: {
                            is: function (x) {
                                return _.inRange(x, 91, 101);
                            },
                            msg: 'Значительное повышение правожелудочкового сердечного выброса',
                            style: 'primary'
                        },
                        58: {
                            is: function (x) {
                                return _.inRange(x, 81, 91);
                            },
                            msg: 'Повышенный правожелудочковый сердечный выброс',
                            style: 'warning'
                        },
                        59: {
                            is: function (x) {
                                return _.inRange(x, 61, 81);
                            },
                            msg: 'Нормальный правожелудочковый сердечный выброс',
                            style: 'success'
                        },
                        60: {
                            is: function (x) {
                                return _.inRange(x, 51, 61);
                            },
                            msg: 'Сниженный правожелудочковый сердечный выброс',
                            style: 'warning'
                        },
                        61: {
                            is: function (x) {
                                return _.inRange(x, 41, 51);
                            },
                            msg: 'Значительное снижение правожелудочкового сердечного выброса',
                            style: 'primary'
                        },
                        62: {
                            is: function (x) {
                                return x < 41;
                            },
                            msg: 'Угрожающее снижение правожелудочкового сердечного выброса',
                            style: 'danger'
                        }
                    }
                },
                SVRa: {
                    id: 'SVRa',
                    name: 'ОПСС бк',
                    description: 'Общее периферическое сопротивление сосудов большого круга кровообращения',
                    dimension: 'дин см с<sup>-5</sup>',
                    data: [],
                    min: 0,
                    max: 1500,
                    diagnosis: {
                        63: {
                            is: function (x) {
                                return x > 1100;
                            },
                            msg: 'Развитие интерстициального отёка тканей БКК',
                            style: 'danger'
                        },
                        64: {
                            is: function (x) {
                                return _.inRange(x, 1001, 1101);
                            },
                            msg: 'Значительное увеличение количества раскрытых микрососудов в БКК',
                            style: 'primary'
                        },
                        65: {
                            is: function (x) {
                                return _.inRange(x, 881, 1001);
                            },
                            msg: 'Увеличение количества раскрытых микрососудов в БКК',
                            style: 'warning'
                        },
                        66: {
                            is: function (x) {
                                return _.inRange(x, 681, 881);
                            },
                            msg: 'Удовлетворительная функция микрососудов БКК',
                            style: 'success'
                        },
                        67: {
                            is: function (x) {
                                return _.inRange(x, 601, 681);
                            },
                            msg: 'Снижение количества функционирующих микрососудов в БКК',
                            style: 'warning'
                        },
                        68: {
                            is: function (x) {
                                return x < 601;
                            },
                            msg: 'Развитие тканевой гипоксии в БКК',
                            style: 'primary'
                        }
                    }
                },
                SVRv: {
                    id: 'SVRv',
                    name: 'ОПСС мк',
                    description: 'Общее периферическое сопротивление сосудов малого круга кровообращения',
                    dimension: 'дин см с<sup>-5</sup>',
                    data: [],
                    min: 0,
                    max: 1500,
                    diagnosis: {
                        69: {
                            is: function (x) {
                                return x > 1100;
                            },
                            msg: 'Развитие интерстициального отёка тканей МКК',
                            style: 'danger'
                        },
                        70: {
                            is: function (x) {
                                return _.inRange(x, 1001, 1101);
                            },
                            msg: 'Значительное увеличение количества раскрытых микрососудов в МКК',
                            style: 'primary'
                        },
                        71: {
                            is: function (x) {
                                return _.inRange(x, 881, 1001);
                            },
                            msg: 'Увеличение количества раскрытых микрососудов в МКК',
                            style: 'warning'
                        },
                        72: {
                            is: function (x) {
                                return _.inRange(x, 681, 881);
                            },
                            msg: 'Удовлетворительная функция микрососудов МКК',
                            style: 'success'
                        },
                        73: {
                            is: function (x) {
                                return _.inRange(x, 601, 681);
                            },
                            msg: 'Снижение количества функционирующих микрососудов в МКК',
                            style: 'warning'
                        },
                        74: {
                            is: function (x) {
                                return x < 601;
                            },
                            msg: 'Развитие тканевой гипоксии в МКК',
                            style: 'primary'
                        }
                    }
                },
                bv: {
                    id: 'bv',
                    name: 'ОЦК',
                    description: 'Объём циркулирующей крови (% от массы тела)',
                    dimension: '%',
                    data: [],
                    min: 0,
                    max: 135,
                    converter: function (x) {
                        return Math.round(Math.max(0.2, Math.min(x, 1.3)) * 100);
                    },
                    diagnosis: {
                        75: {
                            is: function (x) {
                                return x > 1.20;
                            },
                            msg: 'Тяжёлая гиперволемия',
                            style: 'dark'
                        },
                        76: {
                            is: function (x) {
                                return _.inRange(x, 1.11, 1.21);
                            },
                            msg: 'Выраженная гиперволемия',
                            style: 'danger'
                        },
                        77: {
                            is: function (x) {
                                return _.inRange(x, 1.01, 1.11);
                            },
                            msg: 'Умеренная гиперволемия',
                            style: 'warning'
                        },
                        78: {
                            is: function (x) {
                                return _.inRange(x, 0.81, 1.01);
                            },
                            msg: 'Нормоволемия',
                            style: 'success'
                        },
                        79: {
                            is: function (x) {
                                return _.inRange(x, 0.71, 0.81);
                            },
                            msg: 'Умеренная гиповолемия',
                            style: 'primary'
                        },
                        80: {
                            is: function (x) {
                                return _.inRange(x, 0.61, 0.71);
                            },
                            msg: 'Выраженная гиповолемия',
                            style: 'danger'
                        },
                        81: {
                            is: function (x) {
                                return x < 0.61;
                            },
                            msg: 'Тяжёлая гиповолемия',
                            style: 'dark'
                        }
                    }
                },
                ia: {
                    id: 'ia',
                    name: 'ИССА',
                    description: 'Индекс сердечно-сосудистой адаптации',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 3.3,
                    converter: function (x) {
                        return Math.max(0.26, Math.min(x, 3.26));
                    },
                    diagnosis: {
                        82: {
                            is: function (x) {
                                return x > 1.05;
                            },
                            msg: 'Угроза развития критического состояния',
                            style: 'dark'
                        },
                        83: {
                            is: function (x) {
                                return _.inRange(x, 0.81, 1.06);
                            },
                            msg: 'Выраженная сердечно-сосудистая нестабильность',
                            style: 'danger'
                        },
                        84: {
                            is: function (x) {
                                return _.inRange(x, 0.71, 0.81);
                            },
                            msg: 'Нарушение стабильности сердечно-сосудистой деятельности',
                            style: 'warning'
                        },
                        85: {
                            is: function (x) {
                                return _.inRange(x, 0.51, 0.71);
                            },
                            msg: 'Удовлетворительная сердечно-сосудистая адаптация',
                            style: 'success'
                        },
                        86: {
                            is: function (x) {
                                return _.inRange(x, 0.41, 0.51);
                            },
                            msg: 'Снижение сердечно-сосудистой адаптации',
                            style: 'warning'
                        },
                        87: {
                            is: function (x) {
                                return x < 0.41;
                            },
                            msg: 'Пороговое снижение сердечно-сосудистой адаптации',
                            style: 'primary'
                        }
                    }
                },
                ipa: {
                    id: 'ipa',
                    name: 'ИЛА',
                    description: 'Индекс лёгочной адаптации',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 3.3,
                    converter: function (x) {
                        return Math.max(0.26, Math.min(x, 3.26));
                    },
                    diagnosis: {
                        88: {
                            is: function (x) {
                                return x > 2.70;
                            },
                            msg: 'Высокая вероятность развития отёка лёгких',
                            style: 'dark'
                        },
                        89: {
                            is: function (x) {
                                return _.inRange(x, 1.71, 2.71);
                            },
                            msg: 'Угроза острого респираторного дистресс-синдрома',
                            style: 'danger'
                        },
                        90: {
                            is: function (x) {
                                return _.inRange(x, 1.01, 1.71);
                            },
                            msg: 'Признаки синдрома острого повреждения лёгких',
                            style: 'primary'
                        },
                        91: {
                            is: function (x) {
                                return _.inRange(x, 0.81, 1.01);
                            },
                            msg: 'Функциональные нарушения лёгочной адаптации',
                            style: 'warning'
                        },
                        92: {
                            is: function (x) {
                                return _.inRange(x, 0.61, 0.81);
                            },
                            msg: 'Удовлетворительная лёгочная адаптация',
                            style: 'success'
                        },
                        93: {
                            is: function (x) {
                                return _.inRange(x, 0.46, 0.61);
                            },
                            msg: 'Повышение «воздушности» лёгочной ткани',
                            style: 'warning'
                        },
                        94: {
                            is: function (x) {
                                return x < 0.46;
                            },
                            msg: 'Пороговое повышение «воздушности» лёгочной ткани',
                            style: 'primary'
                        }
                    }
                },
                iemo: {
                    id: 'iemo',
                    name: 'ИЭМО',
                    description: 'Индекс эндокринно-метаболического отягощения',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 3.3,
                    converter: function (x) {
                        return Math.max(0.26, Math.min(x, 3.26));
                    },
                    diagnosis: {
                        111: {
                            is: function (x) {
                                return x > 2.04;
                            },
                            msg: 'Эндокринно-метаболическое отягощение II степени',
                            style: 'danger'
                        },
                        112: {
                            is: function (x) {
                                return _.inRange(x, 1.57, 2.05);
                            },
                            msg: 'Эндокринно-метаболическое отягощение I степени',
                            style: 'primary'
                        },
                        113: {
                            is: function (x) {
                                return _.inRange(x, 1.28, 1.57);
                            },
                            msg: 'Замедление процессов эндокринно-метаболической регуляции',
                            style: 'primary'
                        },
                        114: {
                            is: function (x) {
                                return _.inRange(x, 1.13, 1.28);
                            },
                            msg: 'Удовлетворительный эндокринно-метаболический гомеостаз (медленный тип)',
                            style: 'warning'
                        },
                        115: {
                            is: function (x) {
                                return _.inRange(x, 0.9, 1.13);
                            },
                            msg: 'Устойчивый эндокринно-метаболический гомеостаз',
                            style: 'success'
                        },
                        116: {
                            is: function (x) {
                                return _.inRange(x, 0.79, 0.9);
                            },
                            msg: 'Удовлетворительный эндокринно-метаболический гомеостаз (быстрый тип)',
                            style: 'warning'
                        },
                        117: {
                            is: function (x) {
                                return _.inRange(x, 0.65, 0.79);
                            },
                            msg: 'Ускорение процессов эндокринно-метаболической регуляции',
                            style: 'warning'
                        },
                        118: {
                            is: function (x) {
                                return _.inRange(x, 0.5, 0.65);
                            },
                            msg: 'Истощение',
                            style: 'danger'
                        },
                        119: {
                            is: function (x) {
                                return x < 0.5;
                            },
                            msg: 'Кахексия',
                            style: 'dark'
                        }
                    }
                },
                bmi: {
                    id: 'bmi',
                    name: 'ИМТ',
                    description: 'Индекс массы тела',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 50,
                    diagnosis: {
                        95: {
                            is: function (x) {
                                return x > 40;
                            },
                            msg: 'Избыточный вес IV',
                            style: 'dark'
                        },
                        96: {
                            is: function (x) {
                                return _.inRange(x, 35.1, 41);
                            },
                            msg: 'Избыточный вес III',
                            style: 'danger'
                        },
                        97: {
                            is: function (x) {
                                return _.inRange(x, 30.1, 35.1);
                            },
                            msg: 'Избыточный вес II',
                            style: 'primary'
                        },
                        98: {
                            is: function (x) {
                                return _.inRange(x, 25.1, 30.1);
                            },
                            msg: 'Избыточный вес I',
                            style: 'warning'
                        },
                        99: {
                            is: function (x) {
                                return _.inRange(x, 18.5, 25.1);
                            },
                            msg: 'Нормальный вес',
                            style: 'success'
                        },
                        100: {
                            is: function (x) {
                                return _.inRange(x, 16.0, 18.5);
                            },
                            msg: 'Недостаточный вес I',
                            style: 'primary'
                        },
                        101: {
                            is: function (x) {
                                return x < 16.0;
                            },
                            msg: 'Недостаточный вес II',
                            style: 'danger'
                        }
                    }
                },
                sop: {
                    id: 'sop',
                    name: 'КАБМ',
                    description: 'Коэффициент активности базового (основного) метаболизма',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 3.3,
                    converter: function (x) {
                        return Math.max(0.26, Math.min(x, 3.26));
                    },
                    diagnosis: {
                        102: {
                            is: function (x) {
                                return x > 2.04;
                            },
                            msg: 'Тяжёлый метаболический синдром',
                            style: 'dark'
                        },
                        103: {
                            is: function (x) {
                                return _.inRange(x, 1.57, 2.05);
                            },
                            msg: 'Метаболический синдром средней степени тяжести',
                            style: 'danger'
                        },
                        104: {
                            is: function (x) {
                                return _.inRange(x, 1.28, 1.57);
                            },
                            msg: 'Лёгкий метаболический синдром ',
                            style: 'primary'
                        },
                        105: {
                            is: function (x) {
                                return _.inRange(x, 1.13, 1.28);
                            },
                            msg: 'Функциональные метаболические нарушения',
                            style: 'warning'
                        },
                        106: {
                            is: function (x) {
                                return _.inRange(x, 0.9, 1.13);
                            },
                            msg: 'Удовлетворительный базовый метаболизм',
                            style: 'success'
                        },
                        107: {
                            is: function (x) {
                                return _.inRange(x, 0.79, 0.9);
                            },
                            msg: 'Высокий базовый метаболизм',
                            style: 'warning'
                        },
                        108: {
                            is: function (x) {
                                return _.inRange(x, 0.65, 0.79);
                            },
                            msg: 'Патологическое повышение скорости основного обмена',
                            style: 'primary'
                        },
                        109: {
                            is: function (x) {
                                return _.inRange(x, 0.5, 0.65);
                            },
                            msg: 'Критическое повышение скорости основного обмена',
                            style: 'danger'
                        },
                        110: {
                            is: function (x) {
                                return x < 0.5;
                            },
                            msg: 'Метаболическое «выгорание»',
                            style: 'dark'
                        }
                    }
                },
                kyad: {
                    id: 'kyad',
                    name: 'КЯД',
                    description: 'Коэффициент явной дезадаптации',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 3.3,
                    converter: function (x) {
                        return Math.max(0.26, Math.min(x, 3.26));
                    },
                    diagnosis: {
                        120: {
                            is: function (x) {
                                return x > 2.04;
                            },
                            msg: 'Кардиореспираторный синдром тяжёлой степени',
                            style: 'dark'
                        },
                        121: {
                            is: function (x) {
                                return _.inRange(x, 1.57, 2.05);
                            },
                            msg: 'Кардиореспираторный синдром средней степени',
                            style: 'danger'
                        },
                        122: {
                            is: function (x) {
                                return _.inRange(x, 1.28, 1.57);
                            },
                            msg: 'Кардиореспираторный синдром лёгкой степени',
                            style: 'primary'
                        },
                        123: {
                            is: function (x) {
                                return _.inRange(x, 1.13, 1.28);
                            },
                            msg: 'Умеренная кардиореспираторная дисфункция',
                            style: 'warning'
                        },
                        124: {
                            is: function (x) {
                                return _.inRange(x, 0.9, 1.13);
                            },
                            msg: 'Удовлетворительное состояние механизмов долговременной адаптации',
                            style: 'success'
                        },
                        125: {
                            is: function (x) {
                                return _.inRange(x, 0.79, 0.9);
                            },
                            msg: 'Умеренная кардиоциркуляторная дисфункция',
                            style: 'warning'
                        },
                        126: {
                            is: function (x) {
                                return _.inRange(x, 0.65, 0.79);
                            },
                            msg: 'Кардиоциркуляторный синдром лёгкой степени',
                            style: 'primary'
                        },
                        127: {
                            is: function (x) {
                                return _.inRange(x, 0.5, 0.65);
                            },
                            msg: 'Кардиоциркуляторный синдром средней степени',
                            style: 'danger'
                        },
                        128: {
                            is: function (x) {
                                return x < 0.5;
                            },
                            msg: 'Кардиоциркуляторный синдром тяжёлой степени',
                            style: 'dark'
                        }
                    }
                },
                ksd: {
                    id: 'ksd',
                    name: 'КСД',
                    description: 'Коэффициент скрытой дезадаптации',
                    dimension: 'ед.',
                    data: [],
                    min: 0,
                    max: 3.3,
                    converter: function (x) {
                        return Math.max(0.26, Math.min(x, 3.26));
                    },
                    diagnosis: {
                        120: {
                            is: function (x) {
                                return x > 2.04;
                            },
                            msg: 'Кардиодепрессивный синдром тяжёлой степени',
                            style: 'dark'
                        },
                        121: {
                            is: function (x) {
                                return _.inRange(x, 1.57, 2.05);
                            },
                            msg: 'Кардиодепрессивный синдром средней степени',
                            style: 'danger'
                        },
                        122: {
                            is: function (x) {
                                return _.inRange(x, 1.28, 1.57);
                            },
                            msg: 'Кардиодепрессивный синдром лёгкой степени',
                            style: 'primary'
                        },
                        123: {
                            is: function (x) {
                                return _.inRange(x, 1.13, 1.28);
                            },
                            msg: 'Умеренный кардиодепрессивный дисбаланс',
                            style: 'warning'
                        },
                        133: {
                            is: function (x) {
                                return _.inRange(x, 0.9, 1.13);
                            },
                            msg: 'Удовлетворительное состояние механизмов немедленной адаптации',
                            style: 'success'
                        },
                        125: {
                            is: function (x) {
                                return _.inRange(x, 0.79, 0.9);
                            },
                            msg: 'Умеренный кардиоваскулярный дисбаланс',
                            style: 'warning'
                        },
                        126: {
                            is: function (x) {
                                return _.inRange(x, 0.65, 0.79);
                            },
                            msg: 'Кардиоваскулярный синдром лёгкой степени',
                            style: 'primary'
                        },
                        127: {
                            is: function (x) {
                                return _.inRange(x, 0.5, 0.65);
                            },
                            msg: 'Кардиоваскулярный синдром средней степени',
                            style: 'danger'
                        },
                        128: {
                            is: function (x) {
                                return x < 0.5;
                            },
                            msg: 'Кардиоваскулярный синдром тяжёлой степени',
                            style: 'dark'
                        }
                    }
                },
                odv: {
                    id: 'odv',
                    name: 'ОДВ',
                    description: 'Общая дезадаптационная вероятность (уровень индивидуального здоровья)',
                    dimension: '%',
                    data: [],
                    min: 0,
                    max: 135,
                    converter: function (x) {
                        return Math.round(Math.max(0, Math.min(x, 100)));
                    },
                    diagnosis: {
                        138: {
                            is: function (x) {
                                return x > 87;
                            },
                            msg: 'Неудовлетворительное состояние индивидуального здоровья',
                            style: 'dark'
                        },
                        139: {
                            is: function (x) {
                                return _.inRange(x, 72, 88);
                            },
                            msg: 'Крайне низкий уровень индивидуального здоровья',
                            style: 'danger'
                        },
                        140: {
                            is: function (x) {
                                return _.inRange(x, 56, 72);
                            },
                            msg: 'Низкий уровень индивидуального здоровья',
                            style: 'primary'
                        },
                        141: {
                            is: function (x) {
                                return _.inRange(x, 41, 56);
                            },
                            msg: 'Состояние индивидуального здоровья ниже среднего уровня',
                            style: 'warning'
                        },
                        142: {
                            is: function (x) {
                                return _.inRange(x, 27, 41);
                            },
                            msg: 'Средний уровень индивидуального здоровья',
                            style: 'warning'
                        },
                        143: {
                            is: function (x) {
                                return _.inRange(x, 11, 27);
                            },
                            msg: 'Высокий уровень индивидуального здоровья',
                            style: 'success'
                        },
                        144: {
                            is: function (x) {
                                return x < 11;
                            },
                            msg: 'Оптимальное состояние индивидуального здоровья',
                            style: 'success'
                        }
                    }
                },
            }
        },
    }
</script>